import t from "react";
import p from "./index276.mjs";
const o = ({ onClick: e, disabled: r, dataTestId: n, children: i, ariaLabel: a }) => /* @__PURE__ */ t.createElement(
  "button",
  {
    type: "button",
    "data-testid": n,
    disabled: r,
    onClick: e,
    "aria-label": a
  },
  i
), _ = ({
  amount: e,
  setAmount: r,
  step: n = 1,
  minAmount: i = 0,
  limit: a,
  id: s = "stepper",
  measurement: l,
  onAdd: c,
  onRemove: d
}) => /* @__PURE__ */ t.createElement("div", { className: p.stepper_container, "data-testid": "stepper" }, /* @__PURE__ */ t.createElement(
  o,
  {
    dataTestId: `${s}-subtract-button`,
    disabled: e <= i,
    onClick: () => {
      r(e - n), d && d();
    },
    ariaLabel: I18n.t("booking_engine.information.decrease_quantity")
  },
  "-"
), /* @__PURE__ */ t.createElement("div", { className: p.stepper__amount, "data-testid": `${s}-amount` }, e, l ? ` ${l}` : ""), /* @__PURE__ */ t.createElement(
  o,
  {
    disabled: !!((a || a === 0) && e >= a),
    dataTestId: `${s}-add-button`,
    onClick: () => {
      r(e + n), c && c();
    },
    ariaLabel: I18n.t("booking_engine.information.increase_quantity")
  },
  "+"
)), f = ({
  amount: e,
  setAmount: r,
  step: n = 1,
  minAmount: i = 0,
  limit: a,
  id: s = "stepper",
  measurement: l,
  children: c,
  onAdd: d,
  onRemove: b,
  dataTestId: m
}) => /* @__PURE__ */ t.createElement("div", { "data-testid": m, className: p.stepper, id: s }, /* @__PURE__ */ t.createElement("div", { "data-testid": `${s}-label` }, c), /* @__PURE__ */ t.createElement(
  _,
  {
    amount: e,
    setAmount: r,
    step: n,
    minAmount: i,
    limit: a,
    measurement: l,
    onAdd: d,
    onRemove: b
  }
));
export {
  _ as Stepper,
  f as StepperWithLabel
};
